var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.834C12.5 13.9923 10.2617 12.5007 7.5 12.5007C4.73833 12.5007 2.5 13.9923 2.5 15.834M14.1667 11.6673L15.8333 10.0007M15.8333 10.0007L17.5 8.33398M15.8333 10.0007L14.1667 8.33398M15.8333 10.0007L17.5 11.6673M7.5 10.0007C6.61594 10.0007 5.7681 9.64946 5.14298 9.02434C4.51786 8.39922 4.16667 7.55137 4.16667 6.66732C4.16667 5.78326 4.51786 4.93542 5.14298 4.31029C5.7681 3.68517 6.61594 3.33398 7.5 3.33398C8.38405 3.33398 9.2319 3.68517 9.85702 4.31029C10.4821 4.93542 10.8333 5.78326 10.8333 6.66732C10.8333 7.55137 10.4821 8.39922 9.85702 9.02434C9.2319 9.64946 8.38405 10.0007 7.5 10.0007Z",
    stroke: "#CB8B65",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountClose);
export default __webpack_public_path__ + "static/media/AccountClose.6f770e5d07a43ca8d74375543bcc1dd4.svg";
export { ForwardRef as ReactComponent };